module.exports = __webpack_public_path__ + "img/layer.edeab263.svg";